import { api } from '../../services/ApiService'
import { flatMap } from 'lodash'
import { CamimFirebase } from '../../services/CamimFirebase'

export const fetchPrescriptions = token =>
    api
        .setToken(token)
        .auth()
        .get('prescription/list')

export const fetchPrescriptionsFromFb = async (filials, data) => {
    const results = await Promise.allSettled(
        filials.map(filial => {
            const service = new CamimFirebase()
            return service.request('customerPrescriptions', filial, data)
        })
    )

    return flatMap(
        results.map(result =>
            result.status !== 'fulfilled' ? [] : result.value.result || []
        )
    )
}
